import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  // --- STATES ---
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false); // Slider pause state

  // --- SLIDER DATA ---
  const sliderData = [
    {
      id: 1,
      image: "/images/20251229-1ES_5784.jpg",
      title: "Moldovan PM says each citizen has important role in building safe digital space",
      date: "10-04-2025 13:55",
      views: "1,288",
      desc: "Cybersecurity is a vast field and a continuous process in which both large companies operating digital technologies and every citizen must be involved..."
    },
    {
      id: 2,
      image: "/images/20251229-1ES_4843.jpg",
      title: "Government approves new measures to support agricultural producers affected by drought",
      date: "12-04-2025 09:30",
      views: "945",
      desc: "The Executive approved a series of decisions aimed at supporting farmers, including subsidies and diesel fuel aid for the upcoming season..."
    },
    {
      id: 3,
      image: "/images/20251229-_ES29651.jpg",
      title: "Meeting of the Governmental Commission for European Integration took place today",
      date: "14-04-2025 11:15",
      views: "1,532",
      desc: "Discussions focused on the progress of implementing the National Plan for EU Accession and preparing for the next intergovernmental conference..."
    }
  ];

  // --- SLIDER LOGIC ---
  useEffect(() => {
    let slideInterval;
    if (!isPaused) {
      slideInterval = setInterval(() => {
        setCurrentSlide((prev) => (prev === sliderData.length - 1 ? 0 : prev + 1));
      }, 4000);
    }
    return () => clearInterval(slideInterval);
  }, [isPaused, sliderData.length]);

  return (
    <div className="container mt-4 mb-5">

      {/* --- SECTION 1: HERO BANNER --- */}
      <div className="mb-5 rounded shadow-sm p-5 text-center text-white position-relative overflow-hidden"
           style={{ background: 'linear-gradient(90deg, #003366 0%, #004080 100%)' }}>
        <h1 className="display-5 fw-bold text-uppercase" style={{ fontFamily: 'serif' }}>
          GUVERNUL <span className="fw-bolder">CONSTRUIEȘTE</span>
        </h1>
        <p className="lead opacity-75">Official Portal of the Government of Moldova</p>
      </div>

      {/* --- SECTION 2: NEWS GRID --- */}
      <h4 className="border-bottom border-2 border-primary pb-2 mb-4 text-uppercase fw-bold" style={{ color: '#003366', fontFamily: 'serif' }}>
        Latest News
      </h4>

      <div className="row g-4 mb-5">
        
        {/* === LEFT: SLIDER (Responsive) === */}
        <div className="col-lg-5">
          <div 
            className="card border-0 h-100 shadow-sm"
            onMouseEnter={() => setIsPaused(true)} // Pause on hover
            onMouseLeave={() => setIsPaused(false)}
          >
            {/* Image Container with Aspect Ratio */}
            <div className="position-relative overflow-hidden rounded-top" style={{ paddingTop: '60%' }}>
              <img
                src={sliderData[currentSlide].image}
                className="position-absolute top-0 start-0 w-100 h-100"
                alt="Featured News"
                style={{ objectFit: 'cover', transition: 'transform 0.5s ease' }}
                onError={(e) => { e.target.src = 'https://via.placeholder.com/600x400?text=No+Image'; }} // Fallback image
              />
            </div>

            <div className="card-body d-flex flex-column">
              <h5 className="card-title fw-bold" style={{ color: '#003366', fontFamily: 'serif' }}>
                <Link to="/media" className="text-decoration-none text-reset hover-underline">
                  {sliderData[currentSlide].title}
                </Link>
              </h5>

              <p className="text-muted small mb-3">
                <i className="fa fa-calendar me-1"></i> {sliderData[currentSlide].date}
                <span className="mx-2">|</span>
                <i className="fa fa-eye me-1"></i> {sliderData[currentSlide].views}
              </p>

              <p className="card-text text-secondary small flex-grow-1">
                {sliderData[currentSlide].desc}
              </p>

              {/* Dots */}
              <div className="d-flex gap-2 mt-3 justify-content-center">
                {sliderData.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentSlide(index)}
                    className={`btn btn-sm rounded-circle p-0 ${currentSlide === index ? 'bg-primary' : 'bg-secondary'}`}
                    style={{ width: '10px', height: '10px', opacity: currentSlide === index ? 1 : 0.3 }}
                    aria-label={`Go to slide ${index + 1}`}
                  ></button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* === RIGHT: STATIC LIST === */}
        <div className="col-lg-7">
          <div className="row g-0">
            {[1, 2, 3, 4, 5].map((item, index) => (
              <div key={index} className="col-12 border-bottom py-3 news-item">
                <h6 className="fw-bold mb-1">
                  <Link to="/media" className="text-decoration-none text-dark hover-primary">
                    Moldovan PM discusses security and digital transformation strategies with European partners
                  </Link>
                </h6>
                <small className="text-muted">
                  <i className="fa fa-calendar me-1"></i> 10-04-2025 <i className="fa fa-eye ms-3 me-1"></i> 1,200
                </small>
              </div>
            ))}
          </div>
          
          {/* Button */}
          <div className="text-center mt-4">
            <Link to="/media" className="btn btn-outline-primary px-4 py-2 text-uppercase fw-bold" style={{ borderRadius: 0 }}>
              More Press Releases
            </Link>
          </div>
        </div>
      </div>

      {/* --- SECTION 3: VISIT BANNER --- */}
      <div className="card mb-5 border shadow-sm p-4 text-center bg-white">
        <div className="row align-items-center justify-content-center">
          <div className="col-auto">
            <h2 className="fw-bold mb-0 text-primary" style={{ fontFamily: 'serif' }}>
              Vizitează <span className="fw-light d-block d-md-inline">Casa Guvernului</span>
            </h2>
          </div>
          <div className="col-auto mt-3 mt-md-0">
            <div className="bg-light rounded-circle p-2" style={{width: '60px', height: '60px'}}>
               <i className="fa fa-building fa-2x text-secondary"></i>
            </div>
          </div>
        </div>
      </div>

      {/* --- SECTION 4: COLORED CARDS (UPDATED - CLICKABLE) --- */}
      <div className="row g-4 mb-5">
        <InfoCard 
          color="#C0392B" 
          title="Planul Național de Dezvoltare" 
          icon="fa-arrow-up" 
          link="https://gov.md/ro/content/planul-national" // UPDATE THIS LINK
        />
        <InfoCard 
          color="#003366" 
          title="Informații privind situația energetică" 
          icon="fa-bolt" 
          link="https://gov.md/ro/content/energie" // UPDATE THIS LINK
        />
        <InfoCard 
          color="#F1C40F" 
          textColor="text-white"
          title="Planul Național de Reglementări 2025" 
          icon="fa-file-text" 
          link="https://gov.md/ro/content/reglementari-2025" // UPDATE THIS LINK
        />
        <InfoCard 
          color="#003366" 
          title="Planul Național pentru Aderare la UE" 
          icon="fa-star" 
          link="https://gov.md/ro/content/aderare-ue" // UPDATE THIS LINK
        />
      </div>

      {/* --- SECTION 5: INSTITUTION LINKS --- */}
      <div className="row g-4 mb-5">
        <InstitutionCard title="Președinția" subtitle="Republicii Moldova" img="/10.png" link="https://presedinte.md" />
        <InstitutionCard title="Parlamentul" subtitle="Republicii Moldova" img="/11.png" link="https://parlament.md" />
        <InstitutionCard title="Cancelaria de Stat" subtitle="Guvernul RM" img="/12.png" link="https://cancelaria.gov.md" />
        <InstitutionCard title="Consiliul Superior" subtitle="al Magistraturii" img="/13.png" link="https://csm.md" />
      </div>

      {/* --- SECTION 6: FOOTER LOGOS --- */}
      <div className="row g-3 pb-5 text-center text-md-start">
        <FooterLink text="Particip.gov.md" />
        <FooterLink text="Cariere.gov.md" />
        <FooterLink text="Registrul Actelor Locale" />
        <FooterLink text="Registrul Controalelor" />
      </div>

    </div>
  );
};

// --- SUB-COMPONENTS ---

// UPDATED: Now clickable with 'a' tag
const InfoCard = ({ color, title, icon, link, textColor = "text-white" }) => (
  <div className="col-12 col-md-6">
    <a href={link} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
      <div 
        className={`p-4 rounded shadow-sm h-100 d-flex align-items-center justify-content-between ${textColor}`} 
        style={{ 
          backgroundColor: color, 
          minHeight: '120px', 
          transition: 'transform 0.2s, opacity 0.2s',
          cursor: 'pointer' 
        }}
        onMouseEnter={(e) => { 
          e.currentTarget.style.transform = 'translateY(-5px)'; 
          e.currentTarget.style.boxShadow = '0 .5rem 1rem rgba(0,0,0,.15)';
        }}
        onMouseLeave={(e) => { 
          e.currentTarget.style.transform = 'translateY(0)'; 
          e.currentTarget.style.boxShadow = '0 .125rem .25rem rgba(0,0,0,.075)';
        }}
      >
        <h5 className="fw-normal mb-0 lh-base">{title}</h5>
        <i className={`fa ${icon} fs-1 opacity-50`}></i>
      </div>
    </a>
  </div>
);

const InstitutionCard = ({ title, subtitle, img, link }) => (
  <div className="col-6 col-md-3">
    <a href={link} target="_blank" rel="noreferrer" className="card border-0 shadow-sm h-100 text-decoration-none bg-light institute-card">
      <div className="card-body d-flex flex-column align-items-center justify-content-center py-4 text-center">
        <img src={img} alt={title} className="mb-3" style={{ height: '60px', width: 'auto' }} 
             onError={(e) => { e.target.style.display='none'; }} 
        /> 
        {/* Fallback Icon if image breaks */}
        <i className="fa fa-university fa-2x text-secondary mb-2" style={{display: img ? 'none' : 'block'}}></i>
        
        <h6 className="fw-bold small text-uppercase mb-0" style={{ color: '#003366' }}>
          {title} <br /> {subtitle}
        </h6>
      </div>
    </a>
  </div>
);

const FooterLink = ({ text }) => (
  <div className="col-6 col-md-3">
    <div className="border rounded p-2 d-flex align-items-center justify-content-center justify-content-md-start gap-2 h-100 bg-white hover-shadow" style={{cursor: 'pointer'}}>
      <i className="fa fa-external-link text-muted"></i>
      <span className="small fw-bold text-uppercase text-secondary">{text}</span>
    </div>
  </div>
);

export default Home;